type SectionId = "datos" | "resumen" | "detalle" | "trimestres";

export default function MobileNavTabs({
  active,
  onSelect,
  topOffset = 88,
}: {
  active: SectionId;
  onSelect: (section: SectionId) => void;
  topOffset?: number;
}) {
  const tabs: { id: SectionId; label: string }[] = [
    { id: "datos", label: "Datos" },
    { id: "resumen", label: "Resumen" },
    { id: "detalle", label: "Detalle" },
    { id: "trimestres", label: "Trimestres" },
  ];

  return (
    <div
      className="mobile-only"
      style={{
        position: "sticky",
        top: topOffset,
        zIndex: 30,
        padding: "6px 0",
        marginBottom: "10px",
        background: "linear-gradient(180deg, rgba(248,249,251,0.96), rgba(248,249,251,0.86))",
        backdropFilter: "blur(8px)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "8px",
          background: "#fff",
          border: "1px solid var(--border)",
          borderRadius: "16px",
          padding: "6px",
          boxShadow: "var(--shadow)",
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onSelect(tab.id)}
            style={{
              appearance: "none",
              border: "none",
              borderRadius: "12px",
              padding: "10px 8px",
              fontWeight: 700,
              fontSize: "13px",
              background: active === tab.id ? "var(--brand)" : "#f8fafc",
              color: active === tab.id ? "#fff" : "var(--text)",
              boxShadow: active === tab.id ? "0 4px 12px rgba(59,130,246,0.28)" : "none",
              transition: "all 0.15s ease",
              width: "100%",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
